"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmplifyUrlSearchParams = exports.AmplifyUrl = void 0;
const react_native_1 = require("@aws-amplify/react-native");
(0, react_native_1.loadUrlPolyfill)();
const AmplifyUrl = URL;
exports.AmplifyUrl = AmplifyUrl;
const AmplifyUrlSearchParams = URLSearchParams;
exports.AmplifyUrlSearchParams = AmplifyUrlSearchParams;
